module.exports = __webpack_public_path__ + "img/employee-data-personal.4abf98d2.svg";